import * as React from 'react';

import styles from './SimplifiedHeader.module.scss';

interface SimplifiedHeaderProps {
  title: string;
}

const SimplifiedHeader: React.FC<SimplifiedHeaderProps> = ({ title }) => {
  return (
    <div data-testid="simplified-header" className={styles.simplifiedHeader}>
      {title}
    </div>
  );
};

export default SimplifiedHeader;
